import { render, staticRenderFns } from "./TextInputMultiValue.vue?vue&type=template&id=244654d4"
import script from "./TextInputMultiValue.vue?vue&type=script&lang=ts"
export * from "./TextInputMultiValue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports